import { SortDirection } from "./contentTypes";
import { SortOption } from "./models/sort.model";

export class PagingHelper {
  public createSortOption(fieldName: string, sortDirection: SortDirection) {
    const sortOption: SortOption = {
      field: fieldName
      , direction: sortDirection
    };
    return sortOption;
  }

  public fieldSorter(sortObject: SortOption[]): (left: any, right: any) => number {
    return (left: any, right: any): number =>
      sortObject.map(o => {
        const a = left[o.field];
        const b = right[o.field];

        if (typeof a === 'string' && typeof b === 'string') {
          return a.localeCompare(b) * o.direction;
        }

        if (typeof a === 'number' && typeof b === 'number') {
          return (a - b) * o.direction;
        }

        return 0;
      }).reduce((prev, curr) => prev || curr, 0);
  }
}
